import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad12ad10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "graph-card-action-wrapper" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]

import { h, ref } from 'vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import RexIconV3 from '@/rex-components/RexIconV3.vue';
import AnomalyInfoGraphModal from '@/components/charts/utils/AnomalyInfoGraphModal.vue';
import { replaceSpaceInId } from '../../utils/helper-function';
import { ParamsType, Aggregation } from '@/components/Common/graph.types';

interface Props {
  title?: string | undefined;
  handleZoomOut: () => void;
  handleZoomIn: () => void;
  handleReset: () => void;
  displayExpand: boolean;
  metricName?: string;
  params?: ParamsType;
  serviceName?: string;
  axisLabels?: { x: string; y: string };
  aggregation?: Aggregation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GraphCardActionsV3',
  props: {
    title: { default: '' },
    handleZoomOut: {},
    handleZoomIn: {},
    handleReset: {},
    displayExpand: { type: Boolean, default: true },
    metricName: { default: '' },
    params: { default: () => ({
    condition: {
      name: '',
      entity: {},
    },
    duration: {},
  }) },
    serviceName: { default: '' },
    axisLabels: { default: () => ({ x: '', y: '' }) },
    aggregation: { default: () => ({ req: false }) }
  },
  setup(__props: any) {

const openModal = ref(false);

const props = __props;
const aggregation = ref(props.aggregation);
const { title, handleZoomOut, handleReset, handleZoomIn } = props;

return (_ctx: any,_cache: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "graph-card-action-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleZoomOut) && _unref(handleZoomOut)(...args))),
      id: `${_unref(replaceSpaceInId)(props.metricName)}-zoom-out`
    }, [
      _createVNode(_component_BaseIcon, {
        name: "zoomOut",
        width: "2.438rem",
        height: "2.438rem"
      })
    ], 8, _hoisted_2),
    _createElementVNode("span", {
      class: "graph-card-action-icon",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleZoomIn) && _unref(handleZoomIn)(...args))),
      id: `${_unref(replaceSpaceInId)(props.metricName)}-zoom-in`
    }, [
      _createVNode(_component_BaseIcon, {
        name: "zoomIn",
        width: "2.438rem",
        height: "2.438rem"
      })
    ], 8, _hoisted_3),
    _createElementVNode("span", {
      class: "graph-card-action-icon",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleReset) && _unref(handleReset)(...args))),
      id: `${_unref(replaceSpaceInId)(props.metricName)}-zoom-reset`
    }, [
      _createVNode(_component_BaseIcon, {
        name: "reset",
        width: "1.438rem",
        height: "1.438rem"
      })
    ], 8, _hoisted_4),
    (_ctx.displayExpand)
      ? (_openBlock(), _createBlock(RexButtonV3, {
          key: 0,
          variant: "text",
          icon: h(RexIconV3, { iconName: 'expand' }),
          class: "graph-card-action-btn",
          onOnClick: _cache[3] || (_cache[3] = () => (openModal.value = true)),
          id: `${_unref(replaceSpaceInId)(props.metricName)}-open-modal`
        }, null, 8, ["icon", "id"]))
      : _createCommentVNode("", true),
    (openModal.value)
      ? (_openBlock(), _createBlock(AnomalyInfoGraphModal, {
          key: 1,
          title: _unref(title),
          queryName: "queryGetAIMetricValues",
          onOnClose: _cache[4] || (_cache[4] = () => (openModal.value = false)),
          metricName: _ctx.metricName,
          params: _ctx.params,
          serviceName: _ctx.serviceName,
          axisLabels: _ctx.axisLabels,
          aggregation: aggregation.value
        }, null, 8, ["title", "metricName", "params", "serviceName", "axisLabels", "aggregation"]))
      : _createCommentVNode("", true)
  ]))
}
}

})